import { useEffect, useState } from "react";

const tactsuitAirImgUrl = "/images/tactsuit/tactsuit-air/scroll-interaction";
const TACT_SUIT_IMG_COUNT = 91;

export const useTactsuitAirImgLoaded = () => {
  const [images, setImages] = useState<HTMLImageElement[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 클라이언트 측에서만 이미지 로드
    const loadImages = async () => {
      const loadedImages: HTMLImageElement[] = [];

      const imagePromises = Array.from(
        { length: TACT_SUIT_IMG_COUNT },
        (_, i) => {
          const img = new Image();

          //.webp 우선 로드 실패시 .jpg
          const index = `${i}`.padStart(5, "0");
          img.src = `${tactsuitAirImgUrl}/air_${index}.webp`;
          loadedImages.push(img);

          return new Promise<void>((resolve) => {
            img.onload = () => resolve();
            img.onerror = () => {
              //img 로드 실패시 .jpg 다시시도
              img.src = `${tactsuitAirImgUrl}/air_${index}.jpg`;
              img.onload = () => resolve();
              img.onerror = () => resolve();
            };
          });
        },
      );

      await Promise.all(imagePromises);

      setImages(loadedImages);
      setIsLoaded(true);
    };

    loadImages();
  }, []);

  return {
    images,
    isLoaded,
  };
};
